<template>
    <component v-if="bottomNav.showNav" :is="currentNavType"></component>
</template>

<script>
    import { defineAsyncComponent } from 'vue';
    import { useBottomNavStore } from '@/stores/utils/bottomNav';

    const BottomNav = process.env.VUE_APP_TYPE === 'builder'
        ? defineAsyncComponent(() => import( /* webpackChunkName: "BottomNavBuilder" */ '@/components/navigation/builder/BottomNav'))
        : '';

    export default {
        name: 'BottomNavManager',
        components: {
            BottomNav
        },
        computed: {
            bottomNav() {
                return useBottomNavStore();
            },
            currentNavType() {
                if (process.env.VUE_APP_TYPE === 'builder') {
                    return 'BottomNav';
                } else {
                    return 'none';
                }
            },
        },
        methods: {
            toggleNav() {
                if (process.env.VUE_APP_TYPE === 'builder') {
                    this.bottomNav.toggleNav(true);
                } else {
                    this.bottomNav.toggleNav(false);
                }
            },
        },
        watch: {
            $route() {
                this.toggleNav();
            }
        },
        created() {
            this.toggleNav();
        }
    }
</script>
